import React from 'react'
import { useDispatch } from 'react-redux'
import styles from './ImageEdit.module.scss'

import { PencilSimpleIcon, SparkleIcon, TrashIcon } from '@phosphor-icons/react'
import { ScoopMenu, ScoopMenuItem, ScoopMenuDivider, ScoopButton } from '../../../ui'

import { deleteImage } from '../../../../store/actions'
import { useModal, MODALS } from '../../../modals'

export default function ImageEdit({ isMenuOpen, setIsMenuOpen, id }) {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const dispatch = useDispatch()
    const deleteModal = useModal(MODALS.COMMON.DELETE)
    const uploadModal = useModal(MODALS.COMMON.UPLOAD_IMAGE)

    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setIsMenuOpen(true)
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
        setIsMenuOpen(false)
    }

    const handleDelete = () => {
        dispatch(deleteImage(id))
        setIsMenuOpen(false)
        setAnchorEl(null)
    }

    const handleEdit = async () => {
        await uploadModal.show({ id })
    }

    const createMenuItemHandler = (handler) => (event) => {
        event.stopPropagation()
        handler()
        setAnchorEl(null)
        setIsMenuOpen(false)
    }

    return (
        <>
            <div>
                <ScoopButton
                    variant="text"
                    size="xxs"
                    aria-label="Open menu"
                    className={styles.iconButton}
                    onClick={handleClick}
                    style={{ backgroundColor: 'transparent' }}
                >
                    <SparkleIcon size={32} weight="fill" className={styles.sparkleIcon} />
                </ScoopButton>
                <ScoopMenu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <ScoopMenuItem
                        leftSection={<PencilSimpleIcon size={18} weight="regular" />}
                        primary="Edit"
                        onClick={createMenuItemHandler(handleEdit)}
                    />
                    <ScoopMenuDivider />
                    <ScoopMenuItem
                        leftSection={<TrashIcon size={18} weight="regular" />}
                        primary="Delete"
                        onClick={createMenuItemHandler(() =>
                            deleteModal.show({
                                title: 'this image',
                                type: 'Image',
                                onDelete: handleDelete,
                            })
                        )}
                    />
                </ScoopMenu>
            </div>
        </>
    )
}
